import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, Button, DatePicker } from "antd";

const LifetimeMembershipForm = () => {
  const formik = useFormik({
    initialValues: {
      memberName: "",
      membershipNo: "",
      address: "",
      mobileNo: "",
      email: "",
      dob: "",
      joiningDate: "",
      noOfYears: "",
    },
    validationSchema: Yup.object({
      memberName: Yup.string().required("Required"),
      membershipNo: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      mobileNo: Yup.string().required("Required"),
      email: Yup.string().email("Invalid email").required("Required"),
       dob: Yup.date()
    .typeError("Please enter a valid date")
    .required("Date of Birth is required")
    .max(new Date(), "Date of Birth cannot be in the future"),

      joiningDate: Yup.string().required("Required"),
      noOfYears: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      console.log("✅ Form Submitted:", values);
    },
  });


  //  onSubmit: async (values, { resetForm, setSubmitting }) => {
  //     try {
  //       // 🔹 API payload (match backend keys if needed)
  //       const payload = {
  //         member_name: values.memberName,
  //         membership_no: values.membershipNo,
  //         address: values.address,
  //         mobile: values.mobileNo,
  //         email: values.email,
  //         dob: values.dob,
  //         joining_date: values.joiningDate,
  //         no_of_years: values.noOfYears,
  //       };

  //       const response = await axios.post(
  //         `${process.env.REACT_APP_API_URL}lifetime-membership`,
  //         payload,
  //         {
  //           headers: {
  //             Accept: "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("useAccessToken")}`,
  //           },
  //         }
  //       );

  //       console.log("✅ API Response:", response.data);

  //       toast.success("Lifetime membership application submitted successfully!");
  //       resetForm(); // ✅ reset after success

  //     } catch (error) {
  //       console.error("❌ Submission error:", error);

  //       // 🔹 Backend message handling
  //       const message =
  //         error?.response?.data?.message ||
  //         "Failed to submit lifetime membership application";

  //       toast.error(message);
  //     } finally {
  //       setSubmitting(false);
  //     }
  //   }

  // 🔹 Live console log on every change
  useEffect(() => {
    console.log("Current Values:", formik.values);
  }, [formik.values]);

  const renderInput = (name, placeholder, type = "text") => (
    <div>
      <Input
        name={name}
        type={type}
        placeholder={placeholder}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        size="large"
      />
      {formik.touched[name] && formik.errors[name] && (
        <p className="text-red-500 text-sm">{formik.errors[name]}</p>
      )}
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-xl">
      <h2 className="text-center text-2xl font-bold mb-6">
        APPLICATION FOR LIFETIME MEMBERSHIP <br />
        <span className="text-base">(SENIOR CITIZEN CARD)</span>
      </h2>

      <div className="mb-4">
        <h3 className="text-xl font-medium">To,</h3>
        <h3 className="text-xl font-medium">The President / General Secretary</h3>
        <h3 className="text-xl font-medium">Association of Cine & Television Art Directors & Costume Designers</h3>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <table className="table-auto w-full border border-gray-300">
          <tbody>
            <tr>
              <td className="p-2 font-semibold">Member’s Name</td>
              <td colSpan={3} className="p-2">
                {renderInput("memberName", "Enter Member Name")}
              </td>
            </tr>

            <tr>
              <td className="p-2 font-semibold">Membership No.</td>
              <td colSpan={3} className="p-2">
                {renderInput("membershipNo", "Enter Membership No")}
              </td>
            </tr>

            <tr>
              <td className="p-2 font-semibold">Address</td>
              <td colSpan={3} className="p-2">
                {renderInput("address", "Enter Address")}
              </td>
            </tr>

            <tr>
              <td className="p-2 font-semibold">mobile No.</td>
              <td className="p-2">{renderInput("mobileNo", "Enter mobile No")}</td>
              <td className="p-2 font-semibold">Date of Birth</td>
              <td colSpan={3} className="p-2">
                <DatePicker
                  className="w-full"
                  onChange={(date, dateString) =>
                    formik.setFieldValue("dob", dateString)
                  }
                />
                {formik.touched.dob && formik.errors.dob && (
                  <p className="text-red-500 text-sm">{formik.errors.dob}</p>
                )}
              </td>
            </tr>

            <tr>
                <td className="p-2 font-semibold">Email ID</td>
                <td colSpan={3} className="p-2">{renderInput("email", "Enter Email", "email")}</td>  
            </tr>

            <tr>
              <td className="p-2 font-semibold">Joining Date</td>
              <td className="p-2">
                <DatePicker
                  className="w-full"
                  onChange={(date, dateString) =>
                    formik.setFieldValue("joiningDate", dateString)
                  }
                />
                {formik.touched.joiningDate && formik.errors.joiningDate && (
                  <p className="text-red-500 text-sm">
                    {formik.errors.joiningDate}
                  </p>
                )}
              </td>
              <td className="p-2 font-semibold">No. of Years</td>
              <td className="p-2">{renderInput("noOfYears", "Enter Years")}</td>
            </tr>
          </tbody>
        </table>

        <h1 className="text-xl font-medium mt-4">Thanking you !</h1>

        <div className="flex justify-center mt-6 gap-4">
          <Button type="primary" htmlType="submit" size="large">
            Submit Application
          </Button>
          <Button
            type="default"
            onClick={formik.handleReset}
            size="large"
            danger
          >
            Reset
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LifetimeMembershipForm;
